import React from 'react';
import Config from '../utils/config';
import Label from '../utils/label';

export default function DepositButton(props) {

    function openDepositPage() {
        props.openDepositPage('0', Config.appConfig.SiteTitle);
    }

    return (
        <div className="top-nav__deposit btn btn-secondary btn-withIcon" onClick={openDepositPage}>
            <i className="icon-deposit" />
            {Label.lbl_Deposit}
        </div>
    );
}